import {
  ref,
  serverTimestamp as rtTimestamp,
  onValue,
  onDisconnect,
  update,
} from 'firebase/database';
import {
  serverTimestamp as fsTimestamp,
  doc,
  setDoc,
} from 'firebase/firestore';
import {
  realtimeDb,
  firebaseAuth,
  firestore,
} from '../../config/firebaseClient';
// We'll create two constants which we will write to
// the Realtime database when this device is offline
// or online.
const isOfflineForDatabase = {
  state: 'offline',
  lastChanged: rtTimestamp(),
};

const isOnlineForDatabase = {
  state: 'online',
  lastChanged: rtTimestamp(),
};
//similarly for firestore
const isOfflineForFirestore = {
  state: 'offline',
  lastChanged: fsTimestamp(),
};
const isOnlineForFirestore = {
  state: 'online',
  lastChanged: fsTimestamp(),
};
export const getOnlineStatus = () => {
  // Fetch the current user's ID from Firebase Authentication.
  // const uid = firebase.auth().currentUser.uid;
  const uid = firebaseAuth.currentUser?.uid;
  if (!uid) {
    console.error('no user found');
    return;
  }

  // Create a reference to this user's specific status node.
  // This is where we will store data about being online/offline.
  const userStatusDatabaseRef = ref(realtimeDb, `/status/${uid}`);
  // Create a reference to the special '.info/connected' path in
  // Realtime Database. This path returns `true` when connected
  // and `false` when disconnected.

  const userProfileDoc = doc(firestore, `User/${uid}/UserProfile/${uid}`);
  const connectedRef = ref(realtimeDb, '.info/connected');
  onValue(connectedRef, (snapshot) => {
    // If we're not currently connected, tell firestore .
    if (!snapshot.val()) {
      setDoc(
        userProfileDoc,
        {
          onlineStatus: isOfflineForFirestore,
        },
        { merge: true },
      );
      return;
    }

    // If we are currently connected, then use the 'onDisconnect()'
    // method to add a set which will only trigger once this
    // client has disconnected by closing the app,
    // losing internet, or any other means.
    onDisconnect(userStatusDatabaseRef)
      .update(isOfflineForDatabase)
      .then(function () {
        // The promise returned from .onDisconnect().set() will
        // resolve as soon as the server acknowledges the onDisconnect()
        // request, NOT once we've actually disconnected:
        // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

        // We can now safely set ourselves as 'online' knowing that the
        // server will mark us as offline once we lose connection.
        update(userStatusDatabaseRef, isOnlineForDatabase);
        setDoc(
          userProfileDoc,
          { onlineStatus: isOnlineForFirestore },
          { merge: true },
        );
      });
  });
};
